var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "container-action-bar" },
        [
          _c(
            "CompassTooltip",
            { attrs: { arrow: false } },
            [
              _c("template", { slot: "content" }, [
                _c("span", [_vm._v(_vm._s(_vm.pinStatusLabel))])
              ]),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "pin", size: "small", active: _vm.isPinned },
                    on: { click: _vm.onClickPin }
                  })
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { ref: "customTooltip", class: _vm.customTooltipClasses }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.labels.moreActionsTooltip) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.oneLog.can_edit || _vm.oneLog.can_delete
            ? _c(
                "span",
                [
                  _c(
                    "CompassMenu",
                    {
                      ref: "actionBarMenu",
                      attrs: {
                        size: "small",
                        placement: "top-end",
                        customClass: "container-action-bar__menu",
                        disabled: !_vm.isActionBarVisible
                      }
                    },
                    [
                      _c("CompassIconButton", {
                        attrs: { icon: "action", size: "small" },
                        on: {
                          click: _vm.handleCustomTooltipVisibility,
                          mouseenter: _vm.handleCustomTooltipVisibility,
                          mouseleave: _vm.handleCustomTooltipVisibility
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "template",
                        { slot: "dropdown" },
                        [
                          _vm.canEdit
                            ? _c("CompassMenuItem", {
                                attrs: { label: _vm.labels.menuItemModify },
                                on: {
                                  click: function($event) {
                                    return _vm.editElement(_vm.oneLog)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canDelete
                            ? _c("CompassMenuItem", {
                                attrs: { label: _vm.labels.menuItemDelete },
                                on: {
                                  click: function($event) {
                                    _vm.deleteModal = true
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.deleteModal,
            size: "small",
            title: _vm.$t.__("common.actions.delete_message")
          },
          on: {
            "update:visible": function($event) {
              _vm.deleteModal = $event
            },
            closed: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("div", { staticClass: "dialog__default" }, [
              _c(
                "p",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Confirmez-vous vouloir faire disparaître votre commentaire ?"
                        )
                      ) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                        -\n                        " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Il n’apparaitra plus pour aucun de vos collaborateurs."
                          )
                        ) +
                        "\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                        - " +
                        _vm._s(
                          _vm.$l10n.__("Ceci est une action définitive.")
                        ) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary",
                    disabled: _vm.isDeletePending
                  },
                  on: {
                    click: function($event) {
                      _vm.deleteModal = false
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__("common.actions.delete"),
                    type: "primary-destructive",
                    loading: _vm.isDeletePending
                  },
                  on: {
                    click: function($event) {
                      return _vm.deleteElement(_vm.oneLog)
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }